import { useTranslation } from "react-i18next";
import { Check, Star } from "lucide-react";

const TIERS = ["small", "medium", "large"] as const;

export function RoutingTiers() {
  const { t } = useTranslation();

  return (
    <div className="mt-12 lg:mt-16">
      <p className="text-center text-sm font-heading font-semibold text-primary-foreground/60 uppercase tracking-wider mb-6">
        {t("productPages.atlas.routing.tiers.sectionTitle")}
      </p>

      {/* Included note */}
      <div className="flex items-center justify-center gap-2 mb-8 px-4">
        <Star className="h-4 w-4 text-coral shrink-0" />
        <p className="text-sm text-primary-foreground/70 font-body text-center">
          {t("productPages.atlas.routing.tiers.included")}
        </p>
      </div>

      {/* Tier cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 max-w-4xl mx-auto">
        {TIERS.map((tier) => {
          const features = t(`productPages.atlas.routing.tiers.${tier}.features`, { returnObjects: true }) as string[];
          const volumes = t(`productPages.atlas.routing.tiers.${tier}.volumes`, { returnObjects: true }) as string[];
          const isHighlighted = tier === "small";

          return (
            <div
              key={tier}
              className={`rounded-xl border p-6 transition-shadow ${
                isHighlighted
                  ? "border-coral/40 bg-white/10 shadow-md"
                  : "border-white/15 bg-white/5"
              }`}
            >
              <h4 className="font-heading font-bold text-primary-foreground text-lg mb-1">
                Routing {t(`productPages.atlas.routing.tiers.${tier}.name`)}
              </h4>
              <p className="text-sm text-primary-foreground/60 font-body mb-4">
                {t(`productPages.atlas.routing.tiers.${tier}.price`)}
              </p>

              <ul className="space-y-2">
                {Array.isArray(features) &&
                  features.map((feat, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm font-body text-primary-foreground/90">
                      <Check className="h-4 w-4 text-coral shrink-0 mt-0.5" />
                      <span>{feat}</span>
                    </li>
                  ))}
              </ul>

              {Array.isArray(volumes) && volumes.length > 0 && (
                <div className="mt-4 pt-4 border-t border-white/15">
                  <p className="text-xs font-heading font-semibold text-primary-foreground/50 uppercase tracking-wider mb-2">
                    {t("productPages.atlas.routing.tiers.volumeTitle")}
                  </p>
                  <ul className="space-y-1.5">
                    {volumes.map((vol, i) => (
                      <li key={i} className="text-sm font-body text-primary-foreground/60">
                        {vol}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
